<template>
    <div @click="$emit('click', $event)">
        <PersonAvatar
            v-for="person in selectedAccounts.slice(0, 7)"
            :key="person.id"
            :person="person"
            :size="40"
            class-name="mr-1 mb-1"
        ></PersonAvatar>
        <v-avatar
            v-if="selectedAccounts.length > 7"
            class="mr-1 mb-1 subtitle-1 font-weight-medium cursor-pointer"
            size="40"
            color="n1 add-user"
        >
            +{{ selectedAccounts.length - 7 }}
        </v-avatar>
        <!--v-avatar size="40" color="n1 add-user" class="mb-1">
            <v-icon style="left: -2px;">mdi-account-plus</v-icon>
        </v-avatar-->
    </div>
</template>

<script>
import PersonAvatar from "../../components/PersonAvatar.vue";

export default {
    name: "SelectedUsersMobile",
    components: {
        PersonAvatar
    },
    props: {
        selectedAccounts: {
            type: Array,
            required: true
        },
        errorMessages: {
            type: String,
            default: null
        }
    },
    setup() {
        return {};
    }
};
</script>
